import { EnvConfig } from '@shared/definitions';

export const environment: EnvConfig = {
  featureFlags: {},
  production: true,
  staging: false,
  development: false,
  api: 'https://admin.studytrail.nl',
  facebookAppId: '1113437775762173',
  instrumentationKey: '',
  recaptchaSiteKey: '6Ld_26gdAAAAADg8_qto7AMfF2XWm2fpzZgO0LkL',
};
